import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Switch } from "react-router";

import { excelUploadUrl } from "./urls";
import ExcelUpload from "./views/ExcelUpload";

const ExcelUploadPage = () => {
  const intl = useIntl();
  const ExcelUploadComponent = () => <ExcelUpload />;

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.excelUpload)} />
      <Switch>
        <Route exact path={excelUploadUrl} render={ExcelUploadComponent} />
      </Switch>
    </>
  );
};

export default ExcelUploadPage;
